import React, { useCallback } from "react";
import { Model } from "survey-core";
import { Survey } from "survey-react-ui";
import { updateSegment } from "../../../docuclipper/api";
import { useDispatch } from "react-redux";
import { createAlert } from "../../../redux/reducers/Alerts";
import "survey-core/survey.css";
import { closeSurvey } from "../../../redux/reducers/Survey";

type Props = {};
const surveyJson = {
  // title: "Answer a few short questions so we can customize your experience",
  completeText: {
    default: "Send",
  },
  elements: [
    {
      type: "radiogroup",
      name: "segment",
      isRequired: true,
      title: "Which of the following best describes your job function?",
      showNoneItem: false,
      showOtherItem: true,
      colCount: 1,
      choices: [
        "Accountant/Bookkeeper",
        "Financial Investigator",
        "Business Owner",
        "Family Law",
        "Lender",
        "Individual",
      ],
    },
  ],
};

export const SurveySegment1: React.FC<Props> = ({}) => {
  const dispatch = useDispatch();
  const survey = new Model(surveyJson);
  const surveyComplete = useCallback((sender) => {
    updateSegment(sender.data)
      .then(() => {
        dispatch(closeSurvey());
      })
      .catch((err) => {
        dispatch(
          createAlert({
            message: "Error sending survey",
            timeout: 0,
            type: "error",
          })
        );
        dispatch(closeSurvey());
      });
  }, []);

  survey.onComplete.add(surveyComplete);

  return (
    <>
      <Survey model={survey} />
    </>
  );
};
export default SurveySegment1;
